<script></script>

<template>
    <header class="border-b border-zinc-300/50 bg-white/50 backdrop-blur-sm">
        <div class="mx-auto max-w-400 px-4 py-4 sm:px-6 lg:px-8">
            <img
                src="/images/hexpol-logo.png"
                alt="Hexpo Intranet"
                class="h-7 w-auto"
            />
        </div>
    </header>
</template>
